// @flow
import { Button } from './Button';
import { SvgIcon } from './SvgIcon';

export const Reconnecting = ({ msg }: { msg: string }): React$Node => (
    <div>
        <p className='flex items-center gap-2'><SvgIcon svg='warning-fill' /> <b>{msg}</b></p>
        <p><Button size='sm' kind='primary' className='w-full' onClick={() => window.location.reload()}>Reload</Button></p>
    </div>
)